<script>
  // import {error} from '@sveltejs/kit';
  // throw error(404, {message: "Not Found", hint: "Try later"});
  import { page } from '$app/stores';
  import { Link } from '$client';
  const text = {
    404: 'К сожалению, запрашиваемая страница не найдена.  <br/> Попробуйте перейти на главную страницу.',
    500: 'Упс, кажется сервер сейчас не может вам ответить.<br/>  Попробуйте перейти на главную страницу.',
  };
</script>

<div id="main" class="container">
  <h1>{$page.params.code ?? $page.status}</h1>
  <p>
    {@html text[$page.params.code ?? $page.status]} <br /><span
      >{@html $page.url.searchParams.get('message') ?? $page.error?.message}</span>
  </p>

  <Link href="/">На главную</Link>
</div>

<style lang="scss">
  #main {
    z-index: 1;
    padding-top: 160px;
    padding-bottom: 160px;
    color: #fff;
    font-weight: normal;
    font-size: 20px;
    font-family: Vela Sans;
    line-height: 140%;
    background: url('https://admin.uberi.pro/uploads/Image404page_33b765f9e0.webp');
    background-repeat: no-repeat;
    background-position: center 10%;
    background-size: cover;

    :global(a) {
      position: relative;
      z-index: 2;
      padding: 18px 64px;
      color: #000;
      font-weight: 600;
      font-size: 16px;
      background: #22eaac;
      border-radius: 5px;

      @media only screen and (max-width: 560px) {
        width: 100%;
        max-width: 350px;
        text-align: center;
      }
    }

    box-shadow: inset 0 0 100px rgb(0 0 0 / 40%);

    &::before {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
      display: block;
      width: 100%;
      height: 100%;
      background: rgb(0 0 0 / 35%);
      content: '';
    }
  }

  p {
    position: relative;
    z-index: 2;
    margin-bottom: 60px;

    span {
      color: #22eaac;
      font-size: 0.8em;
    }
  }

  h1 {
    position: relative;
    z-index: 2;
    font-weight: bold;
    font-size: 160px;
    font-family: Vela Sans;
    line-height: 130%;
  }

  @media only screen and (max-width: 560px) {
    #main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    h1 {
      margin-bottom: 0;
      font-size: 140px;
      text-align: center;
    }

    p {
      margin-bottom: 0;
      margin-bottom: 60px;
      text-align: center;
    }
  }

  @media only screen and (max-width: 500px) {
    #main {
      /* stylelint-disable-next-line selector-pseudo-class-no-unknown */
      :global(br) {
        display: none;
      }
    }

    p {
      margin-bottom: 40px;
      text-align: center;
    }
  }
</style>
